export default defineNuxtRouteMiddleware((to, from) => {
  const pageTitle = useState("pageTitle");
  pageTitle.value = null;

  useHead({
    title: "PM360",
  });
});
